export default "/images/f60d610db0a3c3cffff109162d23606f.avif";